// src/index.js
// Install the global ResizeObserver rAF wrapper before anything constructs an
// observer (see Helpers/patchResizeObserver.js).
import './Helpers/patchResizeObserver';
// Stop the mouse wheel from spinning the value of focused number inputs (global guard).
import './Helpers/preventNumberInputWheel';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './app.js';
import { msalInstance, msalReady } from './Services/msalClient.ts';

// CSS imports (unchanged)
import './Css/Style.css';
import './index.css';
import './Css/NavBarElement.css';
import './Css/PricingDetail.css';
import './Css/DataTable.css';
import './Css/Scrollbar.css';
import './Css/Button.css';
import './Css/Link.css';
import './Css/OverWindow.css';
import './Css/ProgressBarDots.css';
import './Css/Input.css';

// Bravo design system (CD-5243 foundation): tokens are global+inert; component
// styles are dormant until a subtree opts in via the .bravo-ds scope class.
import './Css/design-system/tokens.css';
import './Css/design-system/bravo-ds.css';
// App layer: overrides + integration rules kept out of the generated bravo-ds.css.
import './Css/design-system/bravo-app.css';
import './Css/design-system/bravo-period-grid.css';
import './Css/design-system/bravo-mass-item-edit.css';
import './Css/design-system/bravo-graph-legend.css';

import { applyTheme, resolveEffectiveTheme, getStoredTheme, DARK } from './Helpers/themeHelper';

// Apply the resolved theme up front (the inline script in index.html already did this
// pre-paint; this is the canonical apply for the React runtime).
applyTheme(resolveEffectiveTheme());

// While the user has made no explicit choice, keep following the OS live.
if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    if (getStoredTheme() === null) applyTheme(e.matches ? DARK : 'light');
  });
}

const root = createRoot(document.getElementById('root'));

(async () => {
  await msalReady;

  root.render(
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <App />
      </Provider>
    </MsalProvider>
  );
})();
